import type { WantLevel } from "../core/want";

/** The want bar (spec §9.5, §17): fills to 1.0 = "due", turns warm past it. Colour via tokens only. */
export function WantBar({
  value,
  level,
  ceiling = 3,
  className,
}: {
  value: number;
  level: WantLevel;
  ceiling?: number;
  className?: string;
}) {
  const pct = Math.min(100, (value / ceiling) * 100);
  const duePct = Math.min(100, (1 / ceiling) * 100);
  return (
    <div
      className={`drang-want relative ${className ?? ""}`}
      data-level={level}
      role="img"
      aria-label={`want ${value.toFixed(1)}`}
    >
      <span style={{ width: `${pct}%` }} />
      <i
        aria-hidden
        className="absolute top-0 h-full w-px bg-neutral-400 opacity-70"
        style={{ left: `${duePct}%` }}
      />
    </div>
  );
}
